import React from 'react';

/**
 * 공통 라떼 로딩 스피너 컴포넌트
 * @param {Object} props
 * @param {string} props.size - 스피너 크기 ('sm', 'md', 'lg', 'xl')
 * @param {string} props.className - 추가 CSS 클래스
 * @param {string} props.text - 로딩 텍스트 (선택사항)
 */
const LatteSpinner = ({ 
  size = 'md', 
  className = '', 
  text = '' 
}) => {
  // 크기 매핑
  const sizeMap = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8', 
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const spinnerSize = sizeMap[size] || sizeMap.md;

  if (text) {
    return (
      <div className={`flex items-center justify-center ${className}`}>
        <div className={`animate-spin rounded-full ${spinnerSize} border-2 spinner-latte`}></div>
        <span className="ml-3 text-gray-600">{text}</span>
      </div>
    );
  }

  return (
    <div className={`animate-spin rounded-full ${spinnerSize} border-2 spinner-latte ${className}`}></div>
  );
};

export default LatteSpinner;

// 편의 함수들 export
export const LatteSpinnerSm = (props) => <LatteSpinner size="sm" {...props} />;
export const LatteSpinnerMd = (props) => <LatteSpinner size="md" {...props} />;
export const LatteSpinnerLg = (props) => <LatteSpinner size="lg" {...props} />;
export const LatteSpinnerXl = (props) => <LatteSpinner size="xl" {...props} />;

// 텍스트와 함께 사용하는 버전
export const LatteSpinnerWithText = ({ text, size = 'md', className = '' }) => (
  <LatteSpinner size={size} text={text} className={className} />
);
